import { createSlice, current } from "@reduxjs/toolkit";
import {
    getFuelSetup, createSetup, addSensor, addTank, editTank, tankMapSensor,
    finalizeSetup, createEvents, editNotification, deleteSetup,
    changeDevice, deleteSensor,

} from './fuelApi';

export const fuelSlice = createSlice({
    name: 'fuel',
    initialState: {
        view: 'main',
        sensorIndex: 0,
        tankIndex: 0,
        sensorStage: null,
        tankStage: null,
    },
    reducers: {
        changeView: (state, { payload }) => {
            state.view = payload.view;
            if (payload.sensorIndex) {
                state.sensorIndex = payload.sensorIndex;
                if (payload.stage) {
                    state.sensorStage = payload.stage;
                }
            }
            if (payload.tankIndex) {
                state.tankIndex = payload.tankIndex;
                if (payload.stage) {
                    state.tankStage = payload.stage;
                }
            }
        },
        initiateSetup: (state, { payload }) => {
            if (!state[payload.assetId]) {
                state[payload.assetId] = {};
            }
            state[payload.assetId] = payload;
            state.view = "basicDetails";

            return state;
        },
        addBasicDetails: (state, { payload }) => {
            if (!state[payload.assetId]) {
                state[payload.assetId] = {};
            }
            state[payload.assetId] = {
                ...payload,
                sensors: Array(parseInt(payload.noOfSensors)).fill({ status: 'empty' }),
                tanks: Array(parseInt(payload.noOfTanks)).fill({ status: 'empty' }),
                events: 'not_created',
            };
            return state;
        },
        addNewSensor: (state, { payload }) => {
            if (state[payload.assetId].sensors[payload.sensorIndex - 1]) {
                state[payload.assetId].sensors[payload.sensorIndex - 1] = {
                    ...current(state[payload.assetId].sensors[payload.sensorIndex - 1]),
                    ...payload,
                }
            } else {
                state[payload.assetId].sensors[payload.sensorIndex - 1] = payload;
            }
            //state[payload.assetId].sensors[payload.sensorIndex - 1] = payload;
            return state;
        },
        updateCalibration: (state, { payload }) => {
            state[payload.assetId].sensors[payload.sensorIndex - 1] = {
                ...current(state[payload.assetId].sensors[payload.sensorIndex - 1]),
                calibrationCode: payload.calibrationCode,
            };
        },
        addNewTank: (state, { payload }) => {
            if (state[payload.assetId].tanks[payload.tankIndex - 1]) {
                state[payload.assetId].tanks[payload.tankIndex - 1] = {
                    ...current(state[payload.assetId].tanks[payload.tankIndex - 1]),
                    ...payload,
                }
            } else {
                state[payload.assetId].tanks[payload.tankIndex - 1] = payload;
            }
            //state[payload.assetId].tanks[payload.tankIndex - 1] = payload;
            return state;
        },
        addEvent: (state, { payload }) => {
            if (state[payload.assetId].event) {
                state[payload.assetId].event = {
                    ...current(state[payload.assetId].event),
                    ...payload,
                }
            } else {
                state[payload.assetId].event = payload;
            }

            return state;
        }


    },
    extraReducers: {
        [getFuelSetup.pending]: (state, action) => {
            return state;
        },
        [getFuelSetup.fulfilled]: (state, action) => {
            const { payload } = action;
            const { assetId } = action.meta.arg;
            if (!state[assetId]) {
                state[assetId] = {};
            }
            if (payload && payload.error === 'nodata') {
                state.view = "nodata";
            } else {
                //console.log("FS SLICE", payload);
                state.view = "main";
                state[assetId] = payload;
                if (!state[assetId].sensors) {
                    state[assetId].sensors = Array(parseInt(payload.noOfSensors)).fill({
                        status: 'empty'
                    });
                }
                if (!state[assetId].tanks) {
                    state[assetId].tanks = Array(parseInt(payload.noOfTanks)).fill({
                        status: 'empty'
                    });
                }


            }
            if (payload.valid.length === 0) {
                state[assetId].error = null;
                state[assetId].success = "Setup Loaded";
            } else {
                //console.log("GEtsetup issue", action, assetId, state[assetId]);
                state[assetId].error = payload.valid;
            }
            return state;
        },
        [getFuelSetup.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state[action.meta.arg.assetId].dataStatus = 'nodata';
            state.view = "nodata";
            return state;
        },
        [createSetup.fulfilled]: (state, { payload, meta }) => {
            if (!state[payload.assetId]) {
                state[payload.assetId] = {};
            }

            if (payload.setupId) {
                state[payload.assetId].setupId = payload.setupId;
                state[payload.assetId].valid = setupCheck(current(state[payload.assetId]));
            }
            state.view = "main";
            state[payload.assetId].error = null;
            state[payload.assetId].success = "Setup Initial Details Saved";
            return state;
        },
        [createSetup.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [addSensor.fulfilled]: (state, { payload }) => {
            state[payload.assetId].sensors[payload.sensorIndex - 1] = {
                ...current(state[payload.assetId].sensors[payload.sensorIndex - 1]),
                ...payload,
            };
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Sensor Number ${payload.sensorIndex} Saved`;
            state.view = "main";
            return state;
        },
        [addSensor.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [addTank.fulfilled]: (state, { payload }) => {
            state[payload.assetId].tanks[payload.tankIndex - 1] = {
                ...current(state[payload.assetId].tanks[payload.tankIndex - 1]),
                ...payload,
            };
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Tank Number ${payload.tankIndex} Saved`;
            state.view = "main";

            return state;
        },
        [addTank.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [editTank.fulfilled]: (state, { payload }) => {
            state[payload.assetId].error = null;
            state.view = "main";
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Tank Edits Saved`;
            return state;
        },
        [editTank.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [tankMapSensor.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [tankMapSensor.fulfilled]: (state, { meta }) => {
            state[meta.arg.assetId].error = null;
            state.view = "main";
            state[meta.arg.assetId].error = null;
            state[meta.arg.assetId].success = `Tank Sensor Mapping Updated`;
            return state;
        },
        [finalizeSetup.fulfilled]: (state, { payload }) => {
            state[payload.assetId] = {
                ...current(state[payload.assetId]),
                ...payload.setup,
            };
            state[payload.assetId].success = 'Setup Finalized, All Good';
            state.view = "main";
            return state;
        },
        [finalizeSetup.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            return state;
        },
        [createEvents.fulfilled]: (state, { payload }) => {
            state[payload.assetId].event = {
                ...current(state[payload.assetId].event),
                ...payload,
            };
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Events Created`;
            state.view = "main";
            return state;
        },
        [createEvents.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [editNotification.fulfilled]: (state, { payload }) => {
            state[payload.assetId].error = null;
            state.view = "main";
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Event Notifications Edited`;
            return state;
        },
        [editNotification.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [deleteSetup.fulfilled]: (state, { payload }) => {
            state[payload.assetId] = { error: ['No Setup'] };
            state.view = "nodata";
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Setup deleted`;
            return state;
        },
        [deleteSetup.rejected]: (state, action) => {
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [changeDevice.fulfilled]: (state, { payload }) => {
            state[payload.oldImei] = { error: ['No Setup'] };
            state[payload.assetId] = payload.setup;
            state.view = "nodata";
            state[payload.assetId].error = null;
            state[payload.assetId].success = `Device Changed, setup migrated to new IMEI`;
            return state;
        },
        [changeDevice.rejected]: (state, action) => {
            //console.log("Change device reject", action);
            state[action.meta.arg.assetId] = { error: action.payload };
            state.view = "main";
            return state;
        },
        [deleteSensor.rejected]: (state, action) => {
            if (!state[action.meta.arg.assetId]) {
                state[action.meta.arg.assetId] = {};
            }
            state[action.meta.arg.assetId].error = action.payload;
            state.view = "main";
            return state;
        },
        [deleteSensor.fulfilled]: (state, { meta }) => {
            state[meta.arg.assetId].error = null;
            state.view = "main";
            state[meta.arg.assetId].success = `Sensor Deleted`;
            return state;
        },
    },
});
export const {
    changeView, initiateSetup, addBasicDetails, addNewSensor,
    updateCalibration, addNewTank, addEvent,
} = fuelSlice.actions;
export {
    getFuelSetup, createSetup, addSensor, addTank, editTank, tankMapSensor,
    finalizeSetup, createEvents, editNotification, deleteSetup, changeDevice,
    deleteSensor
};

export const fuelSetupSelector = (state) => state.fuel;
export const viewSelector = (state) => state.fuel.view;
export const sensorIndexSelector = (state) => state.fuel.sensorIndex;
export const tankIndexSelector = (state) => state.fuel.tankIndex;
export const sensorStageSelector = (state) => state.fuel.sensorStage;
export const tankStageSelector = (state) => state.fuel.tankStage;


function setupCheck(setup) {

    let basicDetails = true;
    basicKeys().forEach(k => {
        if (!setup.hasOwnProperty(k)) {
            basicDetails = false;
        }
    })

    if (!basicDetails) {
        return {
            basicDetails: false,
            sensors: false,
            tanks: false,
            fullSetup: false,
            events: false,
        }
    } else {
        return {
            basicDetails: true,
            sensors: false,
            tanks: false,
            fullSetup: false,
            events: false,
        }
    }




}


const basicKeys = () => {
    return [
        'assetId', 'vehicleName', 'userid', 'noOfSensors', 'noOfTanks',
        'vehicleType', 'make', 'model', 'setupId'
    ];
}
/*
const sensorBaiscKeys = () => {
    return [
        'assetId', 'sensorSerial', 'sensorIndex', 'calibrationCode', 'sensorId',
    ];
}

const sensorFinalizedKeys = () => {
    return [
        'sensorMac', 'sensorBrand', 'manufacturerSerial'
    ];
}

const tankBasicKeys = () => {
    return [
        'name', 'tankIndex', 'setupId', 'noOfSensors', 'content', 'volume', 'expectedMileage', 'expectedHourly', 'minFillThreshold', 'minTheftThreshold', 'tankId',
    ];
}

const tankFinalizedKeys = () => {
    return [
        'sensors', 'aggregationMethod'
    ];
}
*/